import { render, staticRenderFns } from "./curriculum-details-train.vue?vue&type=template&id=2c3d7475&scoped=true"
import script from "./curriculum-details-train.vue?vue&type=script&lang=js"
export * from "./curriculum-details-train.vue?vue&type=script&lang=js"
import style0 from "./curriculum-details-train.vue?vue&type=style&index=0&id=2c3d7475&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d7475",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3d7475')) {
      api.createRecord('2c3d7475', component.options)
    } else {
      api.reload('2c3d7475', component.options)
    }
    module.hot.accept("./curriculum-details-train.vue?vue&type=template&id=2c3d7475&scoped=true", function () {
      api.rerender('2c3d7475', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/curriculum-details-train.vue"
export default component.exports